import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../api/api';
import { Guest, Order } from '../../types';

interface GuestState {
  guests: Guest[];
  currentGuest: Guest | null;
  guestOrders: Order[];
  loading: boolean;
}

export const fetchGuests = createAsyncThunk('guest/fetchAll', async () => {
  const res = await api.get<Guest[]>('/guests');
  return res.data;
});

export const fetchGuestById = createAsyncThunk('guest/fetchById', async (id: number) => {
  const res = await api.get<Guest>(`/guests/${id}`);
  return res.data;
});

export const createGuest = createAsyncThunk('guest/create', async (data: any) => {
  const res = await api.post<Guest>('/guests', data);
  return res.data;
});

export const updateGuest = createAsyncThunk(
  'guest/update',
  async ({ id, data }: { id: number; data: any }) => {
    const res = await api.put<Guest>(`/guests/${id}`, data);
    return res.data;
  }
);

export const fetchGuestOrders = createAsyncThunk('guest/fetchOrders', async (guestId: number) => {
  const res = await api.get<Order[]>(`/guests/${guestId}/orders`);
  return res.data;
});

const guestSlice = createSlice({
  name: 'guest',
  initialState: { guests: [], currentGuest: null, guestOrders: [], loading: false } as GuestState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGuests.fulfilled, (state, action) => {
        state.guests = action.payload;
        state.loading = false;
      })
      .addCase(fetchGuests.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGuests.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchGuestById.fulfilled, (state, action) => {
        state.currentGuest = action.payload;
      })
      .addCase(createGuest.fulfilled, (state, action) => {
        state.guests.push(action.payload);
      })
      .addCase(updateGuest.fulfilled, (state, action) => {
        const idx = state.guests.findIndex((g) => g.id === action.payload.id);
        if (idx !== -1) state.guests[idx] = action.payload;
      })
      .addCase(fetchGuestOrders.fulfilled, (state, action) => {
        state.guestOrders = action.payload;
      });
  },
});

export default guestSlice.reducer;
